import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  jobStoryLength: 0,
  jobStory: [],
}

export default function jobStoryReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_JOB_STORY:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_JOB_STORY:
      return {...state, saveLoader: action.payload}
    case actions.GET_JOB_STORY:
      return {...state, jobStory: action.payload.jobStory, jobStoryLength: action.payload.jobStoryLength}
    default:
      return state;
  }
}